import React, { FC } from 'react';

import { useGetPartnerDetailsQuery } from 'api';
import { PartnerShareLoader } from '../../components';
import { getRedirectUrl } from '../../helpers';

import Protected from './Protected';

const ProtectedLoader: FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const partnerName = searchParams.get('partner_name');

  const { data: partnerData, isLoading: isPartnerLoading } = useGetPartnerDetailsQuery({
    partner_name: partnerName,
  });

  if (isPartnerLoading) {
    return <PartnerShareLoader />;
  }

  const redirectUrl = getRedirectUrl(partnerData?.getPartnerDetails);
  const validatedPartnerName = partnerData?.getPartnerDetails?.partner_name;

  if (!redirectUrl) {
    throw new Error('Invalid redirect URL');
  }

  if (!validatedPartnerName) {
    throw new Error('Invalid partner name');
  }

  return <Protected partnerName={validatedPartnerName} redirectUrl={redirectUrl} />;
};

export default ProtectedLoader;
